import { render, staticRenderFns } from "./AdditionalServices2.vue?vue&type=template&id=27022a28&"
import script from "./AdditionalServices2.vue?vue&type=script&lang=js&"
export * from "./AdditionalServices2.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalServices2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports